import React, { useState } from "react";
import TextFiledWithLabel from "./TextFieldWithLabel";
import LeadDialog from "./LeadDialog";
import { createRequestData } from "../Utility/apiHelper";

import { requestHideDialogLoader, requestShowDialogLoader } from "../Store/Global/action";
import { useDispatch } from "react-redux";
const NotificationDialog = ({
  url = `${process.env.REACT_APP_BASE_URL}notification`,
  open,
  ownerName,
  destinationType,
  contextPayload,
  onClose,
  enqueueSnackbar,
  internationalise,
  handleValidateCodevalue,
  handleMarkAsReadIfUnread
}) => {

  const [message, setMessage] = useState("");
  const [required, setRequired] = useState(false);
  const dispatch = useDispatch()
  const handleSend = async () => {
    if (!message.trim()) {
      setRequired(true);
      enqueueSnackbar(
        handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"),
        { variant: "error" }
      );
      return;
    }

    const payload = {
      ...contextPayload,
      destinationType,
      message,
    };
    try {
      dispatch(requestShowDialogLoader())
      const response = await createRequestData(payload, url);

      if (response?.status === 200) {
        enqueueSnackbar(
          handleValidateCodevalue(
            internationalise,
            "COMMON_NOTI_SENT_SUCCESSFULLY"
          ),
          { variant: "success" }
        );
        // Only mark as read if currently unread (prevents toggling read items to unread)
        handleMarkAsReadIfUnread?.();
        resetAndClose();
      } else {
        throw new Error();
      }
    } catch {
      enqueueSnackbar(
        handleValidateCodevalue(internationalise, "COMMON_PLEASE_TRY_AGAIN"),
        { variant: "error" }
      );
    }
    finally {
      dispatch(requestHideDialogLoader())
    }
  };

  const resetAndClose = () => {
    setMessage("");
    setRequired(false);
    onClose();
  };

  return (
    <LeadDialog
      open={open}
      handleClose={resetAndClose}
      title={`${handleValidateCodevalue(
        internationalise,
        "COMMON_NOTIFY_TITLE"
      )} ${handleValidateCodevalue(internationalise,ownerName)}`}
      size="sm"
      btnlabel={handleValidateCodevalue(internationalise, "COMMON_SEND")}
      handleSave={handleSend}
    >
      <TextFiledWithLabel
        sx={{ width: "100%" }}
        error={required}
        label={handleValidateCodevalue(internationalise, "COMMON_MESSAGE")}
        handleOnChange={(e) => setMessage(e.target.value)}
        name="message"
        value={message}
        autoFocus
      />
    </LeadDialog>
  );
};

export default NotificationDialog;
